import { render } from "./NotFound.vue?vue&type=template&id=8f24236a&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=8f24236a&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f24236a"]])

export default __exports__